var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38444 5.6377L1.28516 14.0348H4.3591L4.45282 14.7283L4.52779 15.2344H18.398L18.2293 14.5034L16.43 6.10628L16.3362 5.6377H3.38444ZM4.54654 6.83728H15.3616L16.9173 14.0348H5.57743L4.54654 6.83728ZM3.68433 9.36767L4.19041 12.8352H2.82213L3.68433 9.36767ZM7.45179 9.83626V11.0358H14.0495V9.83626H7.45179Z",
    fill: "#20C9AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRes);
export default __webpack_public_path__ + "static/media/res.95de103f9710b1c461db72159c2fd930.svg";
export { ForwardRef as ReactComponent };